module.exports = __webpack_public_path__ + "img/375_banner_2.7ee9aea6.jpg";